import React, { useEffect, useState } from "react";
import axios from "axios";
import Css from '../Component/Css';
import wel from '../Assets/wel.png'
import cloud from '../Assets/cloud.png'
import dashi from '../Assets/dashi.png'
import dashiB from '../Assets/dashiB.png'
import { Spin } from 'antd';
import { useRef } from "react";
import { useInView } from "framer-motion";
import{ BASE_URL} from '../Page/Url'
export default function Weather(props) {
  const ref =useRef(null);
  const isView =useInView(ref,{margin:'-20% 0px -20% 0px'});
  const [loading,setLoading]=useState(true);
  const [weather, setWeather] = useState(null);
  const [dayName, setDayName] = useState(null);
  
 
 
  useEffect(() => {
    const interval = setInterval(() => {
       axios.post(`${BASE_URL}/api/get-weather?`,{
        latitude:props.props?.latitude,
        longitude:props.props?.longitude
       }
            ).then(function (response) {
              
              setWeather(response?.data);
              setLoading(false);
       })
       .catch(function (error) {
         // handle error
       
       })
       .finally(function () {
        
       });
    }, 30000);  
           
      return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div ref={ref} className={Css.CSSTailwind.Weather.Weather_section}> 
        <img className={Css.CSSTailwind.Weather.Image_BackGround} src={wel} alt="" />
        <div className={Css.CSSTailwind.Weather.Weather_contener}>
          {/* title section */}
          <div className={Css.CSSTailwind.Weather.weather_box}>
<div>
  <p className={`${isView?'translation-all duration-500 scale-500':'scale-0'} Poppins Popp-600 ${Css.CSSTailwind.Weather.title}`}>{props.caption?.weather_Title}</p>
  <p className={`${isView?'translation-all duration-500 scale-500':'scale-0'} ${Css.CSSTailwind.Weather.sub_title}`}>{props.caption?.weather_Subtitle
}</p>
</div>
{/* weather section */}
<div   className={Css.CSSTailwind.Weather.weather_list_parent}>
  {/* day one */}
<div 
style={{
  boxShadow:'-3.770686626434326px 7.541373252868652px 30.16549301147461px 2.2624123096466064px rgba(19, 35, 78, 0.20)'
}}
className={`${isView?'translation-all duration-1000 -scale-y-500':'scale-0'} ${Css.CSSTailwind.Weather.weather_list}`}>
  {/* date */}
<div className={Css.CSSTailwind.Weather.dashi_contenor}>
 <img className={Css.CSSTailwind.Weather.dashi_Image} src={dashi} alt="dash image" />
  <div className={Css.CSSTailwind.Weather.dashi_context}>
  <p className={Css.CSSTailwind.Weather.date}>{weather?.today?.date}</p>
{/* {weather?.weather_icon} */}
{loading===false? <img className={Css.CSSTailwind.Weather.icon} src={cloud} alt="" />:''}
  
  {/* info section */}

  </div>
</div>
  <div className={Css.CSSTailwind.Weather.info_section}>
    <div style={{
      borderColor:'gradient(to right, #FFFFFF 70%, #BFBFBF 70%)'
    }} className={Css.CSSTailwind.Weather.weather_item_border}>
  <div 
  className={Css.CSSTailwind.Weather.weather_Item}></div>

    </div>
{loading===false?
  <div className={Css.CSSTailwind.Weather.weather_Item_data}>

    <p className={`${Css.CSSTailwind.Weather.tem} weatherText1`}> {weather?.today?.average_temperature}° </p>
    <p className={`${Css.CSSTailwind.Weather.condtion} weatherText2`}>{weather?.today.interpretation}</p>
    {/* diteal section */}
    <div className={Css.CSSTailwind.Weather.detaile}>
      <div className={Css.CSSTailwind.Weather.detaile_section}>
        <svg className={Css.CSSTailwind.Weather.wind_icon} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_57_46)" filter="url(#filter0_di_57_46)">
<path d="M8.86233 11.8858H4.31758V10.4874H8.86233C9.30894 10.4876 9.74699 10.6099 10.129 10.8413C10.511 11.0726 10.8225 11.4041 11.0296 11.7997C11.2367 12.1954 11.3316 12.6402 11.3039 13.086C11.2763 13.5317 11.1272 13.9614 10.8728 14.3285C10.6184 14.6956 10.2684 14.986 9.86077 15.1684C9.4531 15.3508 9.00329 15.4181 8.56008 15.3631C8.11687 15.3081 7.69717 15.1329 7.34644 14.8564C6.99571 14.5799 6.72733 14.2127 6.57038 13.7946L7.87996 13.3031C7.94721 13.4823 8.06222 13.6396 8.21252 13.7582C8.36282 13.8767 8.54269 13.9518 8.73264 13.9754C8.92258 13.999 9.11536 13.9701 9.29009 13.892C9.46482 13.8138 9.61482 13.6894 9.72386 13.5321C9.8329 13.3747 9.89681 13.1906 9.90867 12.9996C9.92053 12.8085 9.87988 12.6179 9.79113 12.4483C9.70238 12.2787 9.56891 12.1366 9.40519 12.0375C9.24147 11.9383 9.05374 11.8859 8.86233 11.8858ZM5.01677 7.69063H14.4559C14.9025 7.69079 15.3405 7.81317 15.7226 8.04449C16.1046 8.27582 16.416 8.60729 16.6231 9.00297C16.8302 9.39865 16.9251 9.84347 16.8975 10.2892C16.8699 10.735 16.7208 11.1647 16.4664 11.5317C16.212 11.8988 15.862 12.1893 15.4543 12.3716C15.0466 12.554 14.5968 12.6214 14.1536 12.5664C13.7104 12.5114 13.2907 12.3361 12.94 12.0596C12.5893 11.7831 12.3209 11.4159 12.1639 10.9978L13.4735 10.5063C13.5408 10.6855 13.6558 10.8429 13.8061 10.9614C13.9564 11.0799 14.1362 11.155 14.3262 11.1786C14.5161 11.2022 14.7089 11.1734 14.8836 11.0952C15.0584 11.0171 15.2084 10.8926 15.3174 10.7353C15.4264 10.578 15.4904 10.3938 15.5022 10.2028C15.5141 10.0117 15.4734 9.8211 15.3847 9.65151C15.2959 9.48193 15.1625 9.33986 14.9987 9.24071C14.835 9.14156 14.6473 9.0891 14.4559 9.08902H5.01677C4.46046 9.08902 3.92693 8.86803 3.53356 8.47465C3.14018 8.08128 2.91919 7.54775 2.91919 6.99144C2.91919 6.43513 3.14018 5.9016 3.53356 5.50823C3.92693 5.11486 4.46046 4.89386 5.01677 4.89386H10.9599C11.1513 4.89378 11.339 4.84132 11.5028 4.74217C11.6665 4.64302 11.8 4.50095 11.8887 4.33137C11.9775 4.16178 12.0181 3.97114 12.0062 3.7801C11.9944 3.58906 11.9305 3.40491 11.8214 3.2476C11.7124 3.09029 11.5624 2.96582 11.3877 2.88768C11.2129 2.80953 11.0202 2.78069 10.8302 2.80428C10.6403 2.82787 10.4604 2.90299 10.3101 3.0215C10.1598 3.14001 10.0448 3.29739 9.97754 3.4766L8.66795 2.98576C8.86965 2.44935 9.25316 2.0007 9.75166 1.71799C10.2502 1.43529 10.8321 1.33645 11.3959 1.43869C11.9598 1.54094 12.47 1.83779 12.8375 2.27752C13.205 2.71725 13.4066 3.27199 13.4071 3.84507C13.4071 4.4941 13.1493 5.11655 12.6903 5.57549C12.2314 6.03442 11.6089 6.29225 10.9599 6.29225H5.01677C4.83133 6.29225 4.65349 6.36591 4.52236 6.49704C4.39124 6.62816 4.31758 6.806 4.31758 6.99144C4.31758 7.17688 4.39124 7.35472 4.52236 7.48584C4.65349 7.61697 4.83133 7.69063 5.01677 7.69063Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_46" x="-0.74166" y="0" width="19.0429" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_46"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_46" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_46"/>
</filter>
<clipPath id="clip0_57_46">
<rect width="16.7806" height="16.7806" fill="white" transform="translate(1.52075)"/>
</clipPath>
</defs>
</svg>

        <p  className={`${Css.CSSTailwind.Weather.windspeed} weatherOthertext `}>Wind</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>


        <p className={`${Css.CSSTailwind.Weather.persent} weatherOthertext`}> {weather?.today?.wind_speed}</p>
      </div>
      {/* other */}
      <div className={Css.CSSTailwind.Weather.detaile_section}>
     
        <svg className={Css.CSSTailwind.Weather.hum_icon}  width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_57_49)" filter="url(#filter0_di_57_49)">
<path d="M8.91115 2.16775L5.45014 5.62875C4.76571 6.31326 4.29961 7.18535 4.1108 8.13475C3.922 9.08415 4.01895 10.0682 4.38941 10.9625C4.75986 11.8568 5.38718 12.6212 6.19204 13.1589C6.99691 13.6967 7.94316 13.9838 8.91115 13.9838C9.87914 13.9838 10.8254 13.6967 11.6303 13.1589C12.4351 12.6212 13.0624 11.8568 13.4329 10.9625C13.8033 10.0682 13.9003 9.08415 13.7115 8.13475C13.5227 7.18535 13.0566 6.31326 12.3722 5.62875L8.91115 2.16775ZM8.91115 0.19043L13.3608 4.64009C14.2409 5.52015 14.8402 6.64141 15.083 7.86208C15.3258 9.08275 15.2012 10.348 14.7249 11.4978C14.2486 12.6477 13.442 13.6305 12.4072 14.3219C11.3724 15.0134 10.1557 15.3824 8.91115 15.3824C7.66657 15.3824 6.44993 15.0134 5.4151 14.3219C4.38027 13.6305 3.57371 12.6477 3.09742 11.4978C2.62114 10.348 2.49652 9.08275 2.73932 7.86208C2.98212 6.64141 3.58144 5.52015 4.46148 4.64009L8.91115 0.19043Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_49" x="-1.74166" y="0" width="19.0429" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_49"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_49" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_49"/>
</filter>
<clipPath id="clip0_57_49">
<rect width="16.7806" height="16.7806" fill="white" transform="translate(0.520752)"/>
</clipPath>
</defs>
</svg>

        <p className={`${Css.CSSTailwind.Weather.hum} weatherOthertext`}>Rain</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>

       
        <p className={`${Css.CSSTailwind.Weather.km_houre} weatherOthertext`}>{weather?.today?.rain_sum}</p>
      </div>
    </div>
  </div>
  :<div className='lg:mt-[25px] mt-[0px]'>
    <Spin  size="large">
  
</Spin>
</div>
}
  
</div>
{/* day */}
<p className={Css.CSSTailwind.Weather.day}>{!dayName&&'Today'}</p>
</div>
{/* day  two  */}
<div  className={`${isView?'translation-all duration-700 -scale-y-500':'scale-0'} ${Css.CSSTailwind.Weather.weather_list}`}>
  {/* date */}
<div className={Css.CSSTailwind.Weather.dashi_contenor}>
  <img className={Css.CSSTailwind.Weather.dashi_Image} src={dashiB} alt="dash image" />
  <div className={Css.CSSTailwind.Weather.dashi_context}>
  <p className={Css.CSSTailwind.Weather.date}>{weather?.tommorow?.date}</p>
{/* {weather?.weather_icon} */}
{loading===false? <img className={Css.CSSTailwind.Weather.icon} src={cloud} alt="" />:''}
  {/* info section */}

  </div>
</div>
  <div className={Css.CSSTailwind.Weather.info_section}>
    <div  className={Css.CSSTailwind.Weather.weather_item_border}>
  <div 
  className={Css.CSSTailwind.Weather.weather_Item}></div>

    </div>
{loading===false?
  <div className={Css.CSSTailwind.Weather.weather_Item_data}>

    <p  className={`${Css.CSSTailwind.Weather.tem} weatherText1`}> {weather?.tommorow?.average_temperature}° </p>
    <p  className={`${Css.CSSTailwind.Weather.condtion} weatherText2`}>{weather?.tommorow?.interpretation}</p>
    {/* diteal section */}
    <div className={Css.CSSTailwind.Weather.detaile}>
      <div className={Css.CSSTailwind.Weather.detaile_section}>
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_322_3733)">
<path d="M8.30239 12.4766H3.75764V11.0782H8.30239C8.749 11.0784 9.18705 11.2008 9.56908 11.4321C9.95111 11.6634 10.2625 11.9949 10.4697 12.3906C10.6768 12.7862 10.7716 13.2311 10.744 13.6768C10.7164 14.1226 10.5673 14.5523 10.3129 14.9193C10.0585 15.2864 9.70851 15.5769 9.30084 15.7592C8.89316 15.9416 8.44335 16.0089 8.00015 15.9539C7.55694 15.8989 7.13723 15.7237 6.7865 15.4472C6.43577 15.1707 6.16739 14.8035 6.01044 14.3854L7.32003 13.8939C7.38727 14.0731 7.50228 14.2305 7.65258 14.349C7.80289 14.4675 7.98276 14.5426 8.1727 14.5662C8.36265 14.5898 8.55543 14.5609 8.73015 14.4828C8.90488 14.4047 9.05489 14.2802 9.16393 14.1229C9.27297 13.9656 9.33688 13.7814 9.34873 13.5904C9.36059 13.3993 9.31994 13.2087 9.23119 13.0391C9.14244 12.8695 9.00898 12.7275 8.84526 12.6283C8.68153 12.5291 8.4938 12.4767 8.30239 12.4766ZM4.45683 8.28145H13.8959C14.3425 8.28161 14.7806 8.40399 15.1626 8.63531C15.5447 8.86664 15.8561 9.19811 16.0632 9.59379C16.2703 9.98947 16.3652 10.4343 16.3376 10.88C16.3099 11.3258 16.1608 11.7555 15.9064 12.1226C15.652 12.4896 15.3021 12.7801 14.8944 12.9625C14.4867 13.1448 14.0369 13.2122 13.5937 13.1572C13.1505 13.1022 12.7308 12.9269 12.38 12.6504C12.0293 12.374 11.7609 12.0068 11.604 11.5886L12.9136 11.0971C12.9808 11.2763 13.0958 11.4337 13.2461 11.5522C13.3964 11.6707 13.5763 11.7458 13.7662 11.7694C13.9562 11.793 14.149 11.7642 14.3237 11.686C14.4984 11.6079 14.6484 11.4834 14.7575 11.3261C14.8665 11.1688 14.9304 10.9846 14.9423 10.7936C14.9541 10.6026 14.9135 10.4119 14.8247 10.2423C14.736 10.0727 14.6025 9.93068 14.4388 9.83153C14.2751 9.73238 14.0873 9.67992 13.8959 9.67984H4.45683C3.90052 9.67984 3.36699 9.45885 2.97362 9.06547C2.58025 8.6721 2.35925 8.13857 2.35925 7.58226C2.35925 7.02595 2.58025 6.49242 2.97362 6.09905C3.36699 5.70568 3.90052 5.48468 4.45683 5.48468H10.4C10.5914 5.4846 10.7791 5.43214 10.9428 5.33299C11.1066 5.23384 11.24 5.09177 11.3288 4.92219C11.4175 4.7526 11.4582 4.56196 11.4463 4.37092C11.4345 4.17988 11.3705 3.99573 11.2615 3.83842C11.1525 3.68111 11.0025 3.55664 10.8277 3.4785C10.653 3.40035 10.4602 3.37151 10.2703 3.3951C10.0803 3.41869 9.90047 3.49381 9.75016 3.61232C9.59986 3.73083 9.48485 3.88821 9.41761 4.06742L8.10802 3.57658C8.30972 3.04017 8.69323 2.59152 9.19173 2.30881C9.69023 2.02611 10.2721 1.92727 10.836 2.02951C11.3999 2.13176 11.91 2.42861 12.2775 2.86834C12.6451 3.30807 12.8466 3.86281 12.8471 4.43589C12.8471 5.08492 12.5893 5.70737 12.1304 6.16631C11.6715 6.62524 11.049 6.88307 10.4 6.88307H4.45683C4.27139 6.88307 4.09355 6.95673 3.96243 7.08786C3.8313 7.21898 3.75764 7.39682 3.75764 7.58226C3.75764 7.7677 3.8313 7.94554 3.96243 8.07666C4.09355 8.20779 4.27139 8.28145 4.45683 8.28145Z" fill="black"/>
</g>
<defs>
<filter id="filter0_di_322_3733" x="-1.3016" y="0.59082" width="19.0431" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_3733"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_3733" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_322_3733"/>
</filter>
</defs>
</svg>


        <p  className={`${Css.CSSTailwind.Weather.windspeed} weatherOthertext`}>Wind</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>


        <p className={`${Css.CSSTailwind.Weather.persent} weatherOthertext`}> {weather?.tommorow?.wind_speed}</p>
      </div>
      {/* other */}
      <div className={Css.CSSTailwind.Weather.detaile_section}>
     
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_322_3736)" filter="url(#filter0_di_322_3736)">
<path d="M9.35109 2.75857L5.89008 6.21957C5.20565 6.90408 4.73955 7.77617 4.55075 8.72557C4.36194 9.67497 4.45889 10.659 4.82935 11.5533C5.1998 12.4476 5.82712 13.212 6.63199 13.7498C7.43685 14.2875 8.3831 14.5746 9.35109 14.5746C10.3191 14.5746 11.2653 14.2875 12.0702 13.7498C12.8751 13.212 13.5024 12.4476 13.8728 11.5533C14.2433 10.659 14.3402 9.67497 14.1514 8.72557C13.9626 7.77617 13.4965 6.90408 12.8121 6.21957L9.35109 2.75857ZM9.35109 0.78125L13.8008 5.23092C14.6808 6.11097 15.2801 7.23223 15.5229 8.4529C15.7657 9.67357 15.6411 10.9388 15.1648 12.0887C14.6885 13.2385 13.882 14.2213 12.8471 14.9128C11.8123 15.6042 10.5957 15.9733 9.35109 15.9733C8.10651 15.9733 6.88987 15.6042 5.85504 14.9128C4.82021 14.2213 4.01365 13.2385 3.53737 12.0887C3.06108 10.9388 2.93646 9.67357 3.17926 8.4529C3.42206 7.23223 4.02138 6.11097 4.90143 5.23092L9.35109 0.78125Z" fill="black"/>
</g>
<defs>
<filter id="filter0_di_322_3736" x="-1.3016" y="0.59082" width="19.0431" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_3736"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_3736" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_322_3736"/>
</filter>
<clipPath id="clip0_322_3736">
<rect width="16.7806" height="16.7806" fill="white" transform="translate(0.960815 0.59082)"/>
</clipPath>
</defs>
</svg>


        <p className={`${Css.CSSTailwind.Weather.hum} weatherOthertext`}>Rain</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>

       
        <p className={`${Css.CSSTailwind.Weather.km_houre}`}>{weather?.tommorow?.rain_sum}</p>
      </div>
    </div>
  </div>
  :<div className='mt-[100px]'>
    <Spin  size="large">
  
</Spin>
</div>}
</div>
{/* day */}
<p className={Css.CSSTailwind.Weather.day}></p>
</div>
{/* day three */}
<div  className={`${isView?'translation-all duration-500 -scale-y-500':'scale-0'} ${Css.CSSTailwind.Weather.weather_list}`}>
  {/* date */}
<div className={Css.CSSTailwind.Weather.dashi_contenor}>
  <img className={Css.CSSTailwind.Weather.dashi_Image} src={dashiB} alt="dash image" />
  <div className={Css.CSSTailwind.Weather.dashi_context}>
  <p className={Css.CSSTailwind.Weather.date}>{weather?.the_day_after_tomorrow?.date}</p>
{/* {weather?.weather_icon} */}
{loading===false? <img className={Css.CSSTailwind.Weather.icon} src={cloud} alt="" />:''}
  {/* info section */}

  </div>
</div>
  <div className={Css.CSSTailwind.Weather.info_section}>
    <div style={{
      borderColor:'gradient(to right, #FFFFFF 70%, #BFBFBF 70%)'
    }} className={Css.CSSTailwind.Weather.weather_item_border}>
  <div 
  className={Css.CSSTailwind.Weather.weather_Item}></div>

    </div>
{loading===false?
  <div className={Css.CSSTailwind.Weather.weather_Item_data}>

    <p className={`${Css.CSSTailwind.Weather.tem} weatherText1`}> {weather?.the_day_after_tomorrow?.average_temperature}° </p>
    <p className={`${Css.CSSTailwind.Weather.condtion} weatherText2`}>{weather?.the_day_after_tomorrow?.interpretation}</p>
    {/* diteal section */}
    <div className={Css.CSSTailwind.Weather.detaile}>
      <div className={Css.CSSTailwind.Weather.detaile_section}>
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_322_3733)">
<path d="M8.30239 12.4766H3.75764V11.0782H8.30239C8.749 11.0784 9.18705 11.2008 9.56908 11.4321C9.95111 11.6634 10.2625 11.9949 10.4697 12.3906C10.6768 12.7862 10.7716 13.2311 10.744 13.6768C10.7164 14.1226 10.5673 14.5523 10.3129 14.9193C10.0585 15.2864 9.70851 15.5769 9.30084 15.7592C8.89316 15.9416 8.44335 16.0089 8.00015 15.9539C7.55694 15.8989 7.13723 15.7237 6.7865 15.4472C6.43577 15.1707 6.16739 14.8035 6.01044 14.3854L7.32003 13.8939C7.38727 14.0731 7.50228 14.2305 7.65258 14.349C7.80289 14.4675 7.98276 14.5426 8.1727 14.5662C8.36265 14.5898 8.55543 14.5609 8.73015 14.4828C8.90488 14.4047 9.05489 14.2802 9.16393 14.1229C9.27297 13.9656 9.33688 13.7814 9.34873 13.5904C9.36059 13.3993 9.31994 13.2087 9.23119 13.0391C9.14244 12.8695 9.00898 12.7275 8.84526 12.6283C8.68153 12.5291 8.4938 12.4767 8.30239 12.4766ZM4.45683 8.28145H13.8959C14.3425 8.28161 14.7806 8.40399 15.1626 8.63531C15.5447 8.86664 15.8561 9.19811 16.0632 9.59379C16.2703 9.98947 16.3652 10.4343 16.3376 10.88C16.3099 11.3258 16.1608 11.7555 15.9064 12.1226C15.652 12.4896 15.3021 12.7801 14.8944 12.9625C14.4867 13.1448 14.0369 13.2122 13.5937 13.1572C13.1505 13.1022 12.7308 12.9269 12.38 12.6504C12.0293 12.374 11.7609 12.0068 11.604 11.5886L12.9136 11.0971C12.9808 11.2763 13.0958 11.4337 13.2461 11.5522C13.3964 11.6707 13.5763 11.7458 13.7662 11.7694C13.9562 11.793 14.149 11.7642 14.3237 11.686C14.4984 11.6079 14.6484 11.4834 14.7575 11.3261C14.8665 11.1688 14.9304 10.9846 14.9423 10.7936C14.9541 10.6026 14.9135 10.4119 14.8247 10.2423C14.736 10.0727 14.6025 9.93068 14.4388 9.83153C14.2751 9.73238 14.0873 9.67992 13.8959 9.67984H4.45683C3.90052 9.67984 3.36699 9.45885 2.97362 9.06547C2.58025 8.6721 2.35925 8.13857 2.35925 7.58226C2.35925 7.02595 2.58025 6.49242 2.97362 6.09905C3.36699 5.70568 3.90052 5.48468 4.45683 5.48468H10.4C10.5914 5.4846 10.7791 5.43214 10.9428 5.33299C11.1066 5.23384 11.24 5.09177 11.3288 4.92219C11.4175 4.7526 11.4582 4.56196 11.4463 4.37092C11.4345 4.17988 11.3705 3.99573 11.2615 3.83842C11.1525 3.68111 11.0025 3.55664 10.8277 3.4785C10.653 3.40035 10.4602 3.37151 10.2703 3.3951C10.0803 3.41869 9.90047 3.49381 9.75016 3.61232C9.59986 3.73083 9.48485 3.88821 9.41761 4.06742L8.10802 3.57658C8.30972 3.04017 8.69323 2.59152 9.19173 2.30881C9.69023 2.02611 10.2721 1.92727 10.836 2.02951C11.3999 2.13176 11.91 2.42861 12.2775 2.86834C12.6451 3.30807 12.8466 3.86281 12.8471 4.43589C12.8471 5.08492 12.5893 5.70737 12.1304 6.16631C11.6715 6.62524 11.049 6.88307 10.4 6.88307H4.45683C4.27139 6.88307 4.09355 6.95673 3.96243 7.08786C3.8313 7.21898 3.75764 7.39682 3.75764 7.58226C3.75764 7.7677 3.8313 7.94554 3.96243 8.07666C4.09355 8.20779 4.27139 8.28145 4.45683 8.28145Z" fill="black"/>
</g>
<defs>
<filter id="filter0_di_322_3733" x="-1.3016" y="0.59082" width="19.0431" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_3733"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_3733" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_322_3733"/>
</filter>
</defs>
</svg>


        <p  className={`${Css.CSSTailwind.Weather.windspeed} weatherOthertext`}>Wind</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>
        <p className={`${Css.CSSTailwind.Weather.persent} weatherOthertext`}> {weather?.the_day_after_tomorrow?.wind_speed}</p>
      </div>
      {/* other */}
      <div className={Css.CSSTailwind.Weather.detaile_section}>
     
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_322_3736)" filter="url(#filter0_di_322_3736)">
<path d="M9.35109 2.75857L5.89008 6.21957C5.20565 6.90408 4.73955 7.77617 4.55075 8.72557C4.36194 9.67497 4.45889 10.659 4.82935 11.5533C5.1998 12.4476 5.82712 13.212 6.63199 13.7498C7.43685 14.2875 8.3831 14.5746 9.35109 14.5746C10.3191 14.5746 11.2653 14.2875 12.0702 13.7498C12.8751 13.212 13.5024 12.4476 13.8728 11.5533C14.2433 10.659 14.3402 9.67497 14.1514 8.72557C13.9626 7.77617 13.4965 6.90408 12.8121 6.21957L9.35109 2.75857ZM9.35109 0.78125L13.8008 5.23092C14.6808 6.11097 15.2801 7.23223 15.5229 8.4529C15.7657 9.67357 15.6411 10.9388 15.1648 12.0887C14.6885 13.2385 13.882 14.2213 12.8471 14.9128C11.8123 15.6042 10.5957 15.9733 9.35109 15.9733C8.10651 15.9733 6.88987 15.6042 5.85504 14.9128C4.82021 14.2213 4.01365 13.2385 3.53737 12.0887C3.06108 10.9388 2.93646 9.67357 3.17926 8.4529C3.42206 7.23223 4.02138 6.11097 4.90143 5.23092L9.35109 0.78125Z" fill="black"/>
</g>
<defs>
<filter id="filter0_di_322_3736" x="-1.3016" y="0.59082" width="19.0431" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_3736"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_3736" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_322_3736"/>
</filter>
<clipPath id="clip0_322_3736">
<rect width="16.7806" height="16.7806" fill="white" transform="translate(0.960815 0.59082)"/>
</clipPath>
</defs>
</svg>


        <p className={`${Css.CSSTailwind.Weather.hum} weatherOthertext`}>Rain</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>

       
        <p className={`${Css.CSSTailwind.Weather.km_houre} weatherOthertext`}>{weather?.the_day_after_tomorrow?.rain_sum}</p>
      </div>
    </div>
  </div>
   :<div className='mt-[100px]'>
   <Spin  size="large">
 
</Spin>
</div>}
</div>
{/* day */}
<p className={Css.CSSTailwind.Weather.day}></p>
</div>
{/* last day */}
<div  className={` ${isView?'translation-all duration-100 -scale-y-500':'scale-0'} ${Css.CSSTailwind.Weather.weather_list}`}>
  {/* date */}
<div className={Css.CSSTailwind.Weather.dashi_contenor}>
  <img className={Css.CSSTailwind.Weather.dashi_Image} src={dashiB} alt="dash image" />
  <div className={Css.CSSTailwind.Weather.dashi_context}>
  <p className={Css.CSSTailwind.Weather.date}>{weather?.fourth_day?.date}</p>
{/* {weather?.weather_icon} */}
{loading===false? <img className={Css.CSSTailwind.Weather.icon} src={cloud} alt="" />:''}
  {/* info section */}

  </div>
</div>
  <div className={Css.CSSTailwind.Weather.info_section}>
    <div style={{
      borderColor:'gradient(to right, #FFFFFF 70%, #BFBFBF 70%)'
    }} className={Css.CSSTailwind.Weather.weather_item_border}>
  <div 
  className={Css.CSSTailwind.Weather.weather_Item}></div>

    </div>
{loading===false?
  <div className={Css.CSSTailwind.Weather.weather_Item_data}>

    <p className={`${Css.CSSTailwind.Weather.tem} weatherText1`}> {weather?.the_day_after_tomorrow?.average_temperature}° </p>
    <p className={`${Css.CSSTailwind.Weather.condtion} weatherText2`}>{weather?.the_day_after_tomorrow?.interpretation}</p>
    {/* diteal section */}
    <div className={Css.CSSTailwind.Weather.detaile}>
      <div className={Css.CSSTailwind.Weather.detaile_section}>
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_322_3733)">
<path d="M8.30239 12.4766H3.75764V11.0782H8.30239C8.749 11.0784 9.18705 11.2008 9.56908 11.4321C9.95111 11.6634 10.2625 11.9949 10.4697 12.3906C10.6768 12.7862 10.7716 13.2311 10.744 13.6768C10.7164 14.1226 10.5673 14.5523 10.3129 14.9193C10.0585 15.2864 9.70851 15.5769 9.30084 15.7592C8.89316 15.9416 8.44335 16.0089 8.00015 15.9539C7.55694 15.8989 7.13723 15.7237 6.7865 15.4472C6.43577 15.1707 6.16739 14.8035 6.01044 14.3854L7.32003 13.8939C7.38727 14.0731 7.50228 14.2305 7.65258 14.349C7.80289 14.4675 7.98276 14.5426 8.1727 14.5662C8.36265 14.5898 8.55543 14.5609 8.73015 14.4828C8.90488 14.4047 9.05489 14.2802 9.16393 14.1229C9.27297 13.9656 9.33688 13.7814 9.34873 13.5904C9.36059 13.3993 9.31994 13.2087 9.23119 13.0391C9.14244 12.8695 9.00898 12.7275 8.84526 12.6283C8.68153 12.5291 8.4938 12.4767 8.30239 12.4766ZM4.45683 8.28145H13.8959C14.3425 8.28161 14.7806 8.40399 15.1626 8.63531C15.5447 8.86664 15.8561 9.19811 16.0632 9.59379C16.2703 9.98947 16.3652 10.4343 16.3376 10.88C16.3099 11.3258 16.1608 11.7555 15.9064 12.1226C15.652 12.4896 15.3021 12.7801 14.8944 12.9625C14.4867 13.1448 14.0369 13.2122 13.5937 13.1572C13.1505 13.1022 12.7308 12.9269 12.38 12.6504C12.0293 12.374 11.7609 12.0068 11.604 11.5886L12.9136 11.0971C12.9808 11.2763 13.0958 11.4337 13.2461 11.5522C13.3964 11.6707 13.5763 11.7458 13.7662 11.7694C13.9562 11.793 14.149 11.7642 14.3237 11.686C14.4984 11.6079 14.6484 11.4834 14.7575 11.3261C14.8665 11.1688 14.9304 10.9846 14.9423 10.7936C14.9541 10.6026 14.9135 10.4119 14.8247 10.2423C14.736 10.0727 14.6025 9.93068 14.4388 9.83153C14.2751 9.73238 14.0873 9.67992 13.8959 9.67984H4.45683C3.90052 9.67984 3.36699 9.45885 2.97362 9.06547C2.58025 8.6721 2.35925 8.13857 2.35925 7.58226C2.35925 7.02595 2.58025 6.49242 2.97362 6.09905C3.36699 5.70568 3.90052 5.48468 4.45683 5.48468H10.4C10.5914 5.4846 10.7791 5.43214 10.9428 5.33299C11.1066 5.23384 11.24 5.09177 11.3288 4.92219C11.4175 4.7526 11.4582 4.56196 11.4463 4.37092C11.4345 4.17988 11.3705 3.99573 11.2615 3.83842C11.1525 3.68111 11.0025 3.55664 10.8277 3.4785C10.653 3.40035 10.4602 3.37151 10.2703 3.3951C10.0803 3.41869 9.90047 3.49381 9.75016 3.61232C9.59986 3.73083 9.48485 3.88821 9.41761 4.06742L8.10802 3.57658C8.30972 3.04017 8.69323 2.59152 9.19173 2.30881C9.69023 2.02611 10.2721 1.92727 10.836 2.02951C11.3999 2.13176 11.91 2.42861 12.2775 2.86834C12.6451 3.30807 12.8466 3.86281 12.8471 4.43589C12.8471 5.08492 12.5893 5.70737 12.1304 6.16631C11.6715 6.62524 11.049 6.88307 10.4 6.88307H4.45683C4.27139 6.88307 4.09355 6.95673 3.96243 7.08786C3.8313 7.21898 3.75764 7.39682 3.75764 7.58226C3.75764 7.7677 3.8313 7.94554 3.96243 8.07666C4.09355 8.20779 4.27139 8.28145 4.45683 8.28145Z" fill="black"/>
</g>
<defs>
<filter id="filter0_di_322_3733" x="-1.3016" y="0.59082" width="19.0431" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_3733"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_3733" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_322_3733"/>
</filter>
</defs>
</svg>


        <p  className={`${Css.CSSTailwind.Weather.windspeed} weatherOthertext`}>Wind</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>


        <p className={`${Css.CSSTailwind.Weather.persent} weatherOthertext`}> {weather?.the_day_after_tomorrow?.wind_speed}</p>
      </div>
      {/* other */}
      <div className={Css.CSSTailwind.Weather.detaile_section}>
     
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_322_3736)" filter="url(#filter0_di_322_3736)">
<path d="M9.35109 2.75857L5.89008 6.21957C5.20565 6.90408 4.73955 7.77617 4.55075 8.72557C4.36194 9.67497 4.45889 10.659 4.82935 11.5533C5.1998 12.4476 5.82712 13.212 6.63199 13.7498C7.43685 14.2875 8.3831 14.5746 9.35109 14.5746C10.3191 14.5746 11.2653 14.2875 12.0702 13.7498C12.8751 13.212 13.5024 12.4476 13.8728 11.5533C14.2433 10.659 14.3402 9.67497 14.1514 8.72557C13.9626 7.77617 13.4965 6.90408 12.8121 6.21957L9.35109 2.75857ZM9.35109 0.78125L13.8008 5.23092C14.6808 6.11097 15.2801 7.23223 15.5229 8.4529C15.7657 9.67357 15.6411 10.9388 15.1648 12.0887C14.6885 13.2385 13.882 14.2213 12.8471 14.9128C11.8123 15.6042 10.5957 15.9733 9.35109 15.9733C8.10651 15.9733 6.88987 15.6042 5.85504 14.9128C4.82021 14.2213 4.01365 13.2385 3.53737 12.0887C3.06108 10.9388 2.93646 9.67357 3.17926 8.4529C3.42206 7.23223 4.02138 6.11097 4.90143 5.23092L9.35109 0.78125Z" fill="black"/>
</g>
<defs>
<filter id="filter0_di_322_3736" x="-1.3016" y="0.59082" width="19.0431" height="19.7973" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.50827" dy="2.26241"/>
<feGaussianBlur stdDeviation="0.377069"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_3736"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_3736" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.754137" dy="0.754137"/>
<feGaussianBlur stdDeviation="0.754137"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_322_3736"/>
</filter>
<clipPath id="clip0_322_3736">
<rect width="16.7806" height="16.7806" fill="white" transform="translate(0.960815 0.59082)"/>
</clipPath>
</defs>
</svg>


        <p className={`${Css.CSSTailwind.Weather.hum} weatherOthertext`}>Rain</p>
        {/* divider */}
        <svg className={Css.CSSTailwind.Weather.divider} width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di_57_39)">
<path d="M2.45409 11.8514V0.461588H3.02044V11.8514H2.45409Z" fill="white"/>
</g>
<defs>
<filter id="filter0_di_57_39" x="0.356522" y="0.461426" width="2.66399" height="14.1869" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-1.39839" dy="2.09758"/>
<feGaussianBlur stdDeviation="0.349597"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_57_39"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_57_39" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-0.699193" dy="0.699193"/>
<feGaussianBlur stdDeviation="0.699193"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow_57_39"/>
</filter>
</defs>
</svg>

       
        <p className={`${Css.CSSTailwind.Weather.km_houre} weatherOthertext`}>{weather?.the_day_after_tomorrow?.rain_sum}</p>
      </div>
    </div>
  </div>
   :<div className='mt-[100px]'>
   <Spin  size="large">
 
</Spin>
</div>
}
</div>
{/* day */}
<p className={Css.CSSTailwind.Weather.day}></p>
</div>

</div>
          </div>
        </div>
      </div>
    </div>
  );
}
